export default function Footer() {
  return (
    <footer className="bg-[#1A2B4C] text-white py-10 sm:py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8 mb-6 sm:mb-8">
          {/* Column 1: About */}
          <div>
            <h3 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4 text-[#C5A880] font-['Playfair_Display']">
              О нас
            </h3>
            <p className="text-sm sm:text-base text-white/80 leading-relaxed font-['Montserrat'] text-justify">
              Профессиональная разработка сайтов с маркетинговой архитектурой и встроенным SEO. Превращаем бизнес в систему генерации прибыли.
            </p>
          </div>

          {/* Column 2: Quick Links */}
          <div>
            <h3 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4 text-[#C5A880] font-['Playfair_Display']">
              Быстрые ссылки
            </h3>
            <ul className="space-y-2 font-['Montserrat']">
              <li>
                <a href="#specialization" className="text-sm sm:text-base text-white/80 hover:text-[#C5A880] transition-colors cursor-pointer">
                  Специализация
                </a>
              </li>
              <li>
                <a href="/case" className="text-sm sm:text-base text-white/80 hover:text-[#C5A880] transition-colors cursor-pointer">
                  Кейсы
                </a>
              </li>
              <li>
                <a href="#lead-form" className="text-sm sm:text-base text-white/80 hover:text-[#C5A880] transition-colors cursor-pointer">
                  Связаться
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3: Contact */}
          <div className="sm:col-span-2 md:col-span-1">
            <h3 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4 text-[#C5A880] font-['Playfair_Display']">
              Контакты
            </h3>
            <ul className="space-y-3 font-['Montserrat']">
              <li className="flex items-center gap-3">
                <i className="ri-mail-line text-[#C5A880] text-lg sm:text-xl"></i>
                <a href="mailto:info@example.com" className="text-sm sm:text-base text-white/80 hover:text-[#C5A880] transition-colors">
                  info@example.com
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-phone-line text-[#C5A880] text-lg sm:text-xl"></i>
                <a href="tel:+79991234567" className="text-sm sm:text-base text-white/80 hover:text-[#C5A880] transition-colors">
                  +7 (999) 123-45-67
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-map-pin-line text-[#C5A880] text-lg sm:text-xl"></i>
                <span className="text-sm sm:text-base text-white/80">Москва, Россия</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-6 sm:pt-8 text-center">
          <p className="text-white/60 text-xs sm:text-sm font-['Montserrat']">
            © 2024 Разработка сайтов. Все права защищены.
          </p>
        </div>
      </div>
    </footer>
  );
}